import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import * as moment from 'moment';
import produce from 'immer';
import { orderBy } from 'lodash-es';
import { PharmOrder, PharmAddress, mapPharmAddress } from '../../models';
import { ApiService, EnvService, SentryService } from '../../services';
import {
  defaultApiStoreData,
  ApiStoreData,
  CcsSentryError,
  MissingApiRequestDataError,
  defaultApiStoreIterableData,
} from '../utils';
import { FetchPharmAddress } from './pharm-address.action';
//import { PatientState } from '../patient/patient.state';

export type PharmAddressStateModel = ApiStoreData<PharmAddress[]>;

@State<PharmAddressStateModel>({
  name: 'pharmAddress',
  defaults: defaultApiStoreIterableData,
})
@Injectable({ providedIn: 'root' })
export class PharmAddressState {
  constructor(
    private apiService: ApiService,
    private store: Store,
    private sentry: SentryService,
    private envService: EnvService
  ) {}

  handleError = this.sentry.handleError;
  handleSuccess = this.sentry.handleSuccess;

  @Selector()
  static pharmAddress(state: PharmAddressStateModel): PharmAddress[] {
    // pharm address
    return state.data;
  }

  @Selector()
  static isLoading(state: PharmAddressStateModel): boolean {
    return state.isLoading;
  }

  @Selector()
  static error(state: PharmAddressStateModel): CcsSentryError | null {
    return state.error;
  }

  @Action(FetchPharmAddress)
  fetchPharmAddress(ctx: StateContext<PharmAddressStateModel>, action: FetchPharmAddress) {
    const processAddressData = (data: PharmAddress[]) => {
      this.handleSuccess({ ctx, data, stateKey: null });
    };

    return this.apiService.getPharmAddress(action.pharmacy, action.patientId, action.customerAddressId).pipe(
      tap({
        next: (response) => {
          const data = response.data.map((p) => mapPharmAddress(p));
          processAddressData(data);
          data;
        },
      }),
      catchError((error: Error): Observable<any> => this.handleError({ ctx, error, stateKey: null }))
    );
  }
}
